import useRebrandVersion from 'hooks/useRebrandVersion'

type RebrandSuccessDarkColour = Extract<App.Design.ContentColour, 'success-dark' | 'highlight-primary-dark'>

/**
 * Rebrand remaps highlight-primary-dark to ocean. Surfaces that should keep the
 * legacy brand-green treatment use messaging success dark instead.
 */
function useRebrandSuccessDarkColour(): RebrandSuccessDarkColour {
  return useRebrandVersion() === 'rebrand' ? 'success-dark' : 'highlight-primary-dark'
}

export default useRebrandSuccessDarkColour
